import { render, staticRenderFns } from "./SelectGroup.vue?vue&type=template&id=04c67e6c&scoped=true"
import script from "./SelectGroup.vue?vue&type=script&lang=js"
export * from "./SelectGroup.vue?vue&type=script&lang=js"
import style0 from "./SelectGroup.vue?vue&type=style&index=0&id=04c67e6c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c67e6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c67e6c')) {
      api.createRecord('04c67e6c', component.options)
    } else {
      api.reload('04c67e6c', component.options)
    }
    module.hot.accept("./SelectGroup.vue?vue&type=template&id=04c67e6c&scoped=true", function () {
      api.rerender('04c67e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/SelectGroup.vue"
export default component.exports